import React, { useState, useEffect } from "react";
import Pagination from "../../../../services/Pagination";
import ExcelServices from "../../../../services/ExcelServices";
import { format } from "date-fns";

const MandatoryPaymentsByMonth = ({ payments, setState }) => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
   
    const currentDate = new Date();
	const year = parseInt(currentDate.getFullYear());
	const years = Array.from(new Array(10), (val, index) => year - index);

    const [searchByYearMonth, setSearchByYearMonth] = useState(false);
	const [paymentsByYearMonth, setPaymentsByYearMonth] = useState([]);

    const [payment_year, setPaymentYear] = useState("");
    const [payment_month, setPaymentMonth] = useState("");

    const [month, setMonth] = useState("");


    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(20);

    const handleSearch = async (e) => {
		e.preventDefault();
	
        const dateFormat = "yyyy-MM-dd";
        let beginDate = new Date(payment_month + '/01/' + payment_year)
        let endDate = new Date(beginDate.getFullYear(), beginDate.getMonth() + 1, 0)
        let paymentMonth = await getPaymentMonth(payment_month)
        setMonth(paymentMonth)
        let begin_date = format(beginDate, dateFormat);
        let end_date = format(endDate, dateFormat);

        // Filter payments by date range
		const requestData = payments?.filter(
			(payment) =>
				payment.payment_date >= begin_date &&
				payment.payment_date <= end_date
        );   
		setPaymentsByYearMonth(requestData);
		setSearchByYearMonth(true);
	};

	const handleBack = () => {
		setSearchByYearMonth(false);
	};

    let total_payments = 0;
    const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	let currentPosts = [];
	if (paymentsByYearMonth.length > 0) {
		currentPosts = paymentsByYearMonth?.slice(
			indexOfFirstPage,
			indexOfLastPage
        );
        for (var i = 0; i < paymentsByYearMonth?.length; i++) {
            total_payments += paymentsByYearMonth[i].payment_amount;
        }
	}
	
   
    const handleByMonthExcel = () => {
        // let total_amount_paid = 0;
	let paymentData = [];
	for (var i = 0; i < paymentsByYearMonth?.length; i++) {
		// total_amount_paid += paymentsByYearMonth[i].payment_amount;
		paymentData.push({
			serial_no: i + 1,
			year: paymentsByYearMonth[i].year,
			pf_number: paymentsByYearMonth[i].pf_number,
			full_name:
				paymentsByYearMonth[i].members?.first_name +
				" " +
				paymentsByYearMonth[i].members?.middle_name +
				" " +
				paymentsByYearMonth[i].members?.last_name,
			mobile_number: paymentsByYearMonth[i].mobile_number,
			payment_amount: paymentsByYearMonth[i].payment_amount,
			payment_date: paymentsByYearMonth[i].payment_date,
		});
        }
       
	let filename = `Mandatory_Payments_${month} - ${payment_year}.xlsx`;
	const headings = [
		[
			"SERIAL NO.",
			"YEAR",
			"PF NUMBER",
			"FULL NAME",
			"MOBILE NUMBER",
			"AMOUNT",
			"PAYMENT DATE",
		],
	];
        
		ExcelServices({ headings, paymentData, filename });
	};

    
    const handleCancel = () => {
		setPaymentsByYearMonth([]);
		setSearchByYearMonth(false);
		setState((prevState) => ({
			...prevState,
			isByDate: false,
			isByMonth: false,
			isAll: true,
		}));
    }

    const searchContent = (
        <>
            <form onSubmit={handleSearch}>
                <div className="form-group row">
                    <label
                      	style={{ fontSize: 16, width: "15%" }}
                        htmlFor="payment_year"
                        className="col-sm-2">Year:
                    </label>
                    <div className="col-sm-2">
                        <select
                            type="text"
                            id="payment_year"
                            autoComplete="off"
                            style={{ fontSize: 16 }}
                            onChange={(e) => setPaymentYear(e.target.value)}
                            required
                            value={payment_year}
                            name="payment_year"
                            className="form-control"
                        >
                            <option></option>
                            {years.map((year, index) => <option value={year} key={`year${index}`}>{year}</option>
                            )}
                        </select>
                    </div>
                    <label
                       	style={{ fontSize: 16, width: "15%" }}
                        htmlFor="month"
                        className="col-sm-2">
                        Month:
                    </label>
                    <div className="col-sm-2">
                        <select
                            type="text"
                            name='month'
                            id='month'
                            style={{ fontSize: 16, textTransform: "uppercase"}}
                            required
                            onChange={(e) => setPaymentMonth(e.target.value)}
                            value={payment_month}
                            className="form-control"
                        >
                            <option></option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                    </div>
                    <div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Search
						</button>
					</div>
					<div className="col-sm-2">
						<button
							onClick={handleCancel}
							className="btn btn-danger btn-block"
						>
							Cancel
						</button>
					</div>
                </div>
            </form>
        </>
    )

    const content =
    paymentsByYearMonth?.length > 0 && searchByYearMonth && (
			<>
				<div>
					<button
						onClick={handleByMonthExcel}
						className="btn btn-success"
					>
						<i className="fa fa-upload"></i>&nbsp; &nbsp;Generate
						Excel File
					</button>
					&nbsp; &nbsp;
				</div>
				<hr />
				<div className="table-responsive lg">
                    <table className="table table-borderless table-striped">
                    <caption className="table-caption">MANDATORY PAYMENTS - {month+" "+payment_year}{" - "} <strong style={{ color: "var(--green)" }}>
							GHS
							{total_payments.toLocaleString(undefined, {
								minimumFractionDigits: 2,
							})}
						</strong></caption>
						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Year</th>
								<th>PF Number</th>
								<th>Full Name</th>
                                <th>Mobile Number</th>
                                <th scope="col">Payment Date</th>
								<th style={{ textAlign: "right" }}>
									Amount Paid
								</th>
							</tr>
						</thead>
						<tbody>
							{currentPosts?.map((mem, index) => (
								<tr key={mem.id}>
									<td style={{ textAlign: "center" }}>
										{postPerPage * (currentPage - 1) +
											index +
											1}
									</td>
									<td>{mem.year}</td>
									<td>{mem.pf_number}</td>
                                    <td>
                                        {mem.members?.first_name+" "+mem.members?.middle_name+" "+mem.members?.last_name}
                                    </td>
                                    <td>{mem.mobile_number}</td>
                                    <td>{mem.payment_date}</td>
									<td style={{ textAlign: "right" }}>
										{mem.payment_amount.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
									</td>
									
								</tr>
							))}
						</tbody>
						<tbody>
                        <tr>
								<th
									colSpan={"6"}
									style={{
										fontSize: "16px",
										fontWeight: "900",
										color: "white",
									}}
								>
									TOTAL MANDATORY PAYMENTS - {month+" "+payment_year}
								</th>
								<th
									style={{
										fontSize: "16px",
										fontWeight: "900",
										color: "white",
										textAlign: "right",
									}}
								>
									{total_payments.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</th>
								<th></th>
							</tr>

						</tbody>
					</table>
				</div>
			</>
		) 

	return (
		<>
            {!searchByYearMonth ? 
                searchContent
             : 
			paymentsByYearMonth.length > 0 ? (
				<>
					<div className="panel-body">{content}</div>
					<div className="panel-footer">
						<Pagination
							data={paymentsByYearMonth}
							postPerPage={postPerPage}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							setPostPerPage={setPostPerPage}
						/>
					</div>
					<div className="box-footer">
						<div className="col-sm-2">
							<button
								onClick={handleBack}
								className="btn btn-success"
							>
								Cancel
							</button>
						</div>
					</div>
				</>
			):(
				<>
					<div className="panel-body">
						<h4>
							No payment transactions for {" "}
							{<b>{month}</b>} and {<b>{payment_year}</b>}
						</h4>
					</div>
					<div className="box-footer">
						<div className="col-sm-2">
                            <button
                                type="button"
								onClick={handleBack}
								className="btn btn-success"
							>
								Cancel
							</button>
						</div>
					</div>
				</>
			)}
		</>
	);
};


export default MandatoryPaymentsByMonth;

async function getPaymentMonth(code) {
    let month = ""
    if (code === '01') {
        month = 'January'
    } else if (code === '02') {
        month = 'February'
    } else if (code === '03') {
        month = 'March'
    } else if (code === '04') {
        month = 'April'
    } else if (code === '05') {
        month = 'May'
    } else if (code === '06') {
        month = 'June'
    } else if (code === '07') {
        month = 'July'
    } else if (code === '08') {
        month = 'August'
    } else if (code === '09') {
        month = 'September'
    } else if (code === '10') {
        month = 'October'
    } else if (code === '11') {
        month = 'November'
    } else {
        month = 'December'
    }
    return month
}
